import React, { useState } from "react";
import {
  Button,
  Container,
  Typography,
  TextField,
  List,
  ListItem,
  ListItemText,
  Box,
  Grid,
} from "@mui/material";
import axios from "axios";
import { keyframes } from "@emotion/react"; // Use emotion keyframes

// Rotation animation
const rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

// Pulse animation (opacity)
const pulse = keyframes`
  0% { opacity: 0.3; }
  50% { opacity: 1; }
  100% { opacity: 0.3; }
`;

// Scale animation (grow/shrink)
const scale = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
`;

function App() {
  const [loading, setLoading] = useState(false);
  const [output, setOutput] = useState("");
  const [totalCodes, setTotalCodes] = useState(0);
  const [redeemedCount, setRedeemedCount] = useState(0);
  const [codes, setCodes] = useState([]);
  const [urls, setUrls] = useState([]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleRunScript = async () => {
    setLoading(true);
    setOutput("");
    setTotalCodes(0);
    setRedeemedCount(0);
    setCodes([]);
    setUrls([]);

    try {
      // const res = await axios.post("http://localhost:5500/run-shift-scraper", {
      const res = await axios.post("https://shift-backend-env.eba-cjnmcs9e.us-east-1.elasticbeanstalk.com/run-shift-scraper", {
        email,
        password,
      });

      if (res.data.success) {
        setTotalCodes(res.data.total_codes || 0);
        setRedeemedCount(res.data.redeemed_count || 0);
        setCodes(res.data.codes || []);
        setUrls(res.data.urls || []);
        setOutput("SHIFT script ran successfully!");
      } else {
        setOutput("Error: " + (res.data.error || "Unknown error"));
      }
    } catch (err) {
      setOutput("Request failed: " + err.message);
    }

    setLoading(false);
  };

  return (
    <Container style={{ marginTop: 50, position: "relative" }}>
      <Typography variant="h4" gutterBottom>
        Run SHIFT Code Script
      </Typography>

      <TextField
        label="Email"
        fullWidth
        margin="normal"
        variant="outlined"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField
        label="Password"
        type="password"
        fullWidth
        margin="normal"
        variant="outlined"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <Button
        variant="contained"
        color="primary"
        onClick={handleRunScript}
        disabled={loading}
        style={{ marginBottom: 20 }}
      >
        Run Script
      </Button>

      <TextField
        label="Script Output"
        multiline
        minRows={5}
        maxRows={10}
        fullWidth
        value={output}
        margin="normal"
        variant="outlined"
        InputProps={{
          readOnly: true,
        }}
      />

      {/* Show grid only when results exist */}
      {totalCodes > 0 && (
        <Grid container spacing={2} alignItems="center" sx={{ marginTop: 2 }}>
          <Grid item xs={12} md={6}>
            <Grid container spacing={1} alignItems="center">
              {/* Image on the left */}
              <Grid item>
                <Box
                  component="img"
                  src="/brent-3.jpg" // Replace with your banner image
                  alt="Success Banner"
                  sx={{
                    width: "auto",
                    height: 400,
                    objectFit: "contain",
                  }}
                />
              </Grid>
              {/* Total Codes Found */}
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle1">
                  Total Codes Found: {totalCodes}
                </Typography>
                <Typography variant="subtitle1">
                  Codes Successfully Redeemed: {redeemedCount}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}

      {codes.length > 0 && (
        <>
          <Typography variant="h6" style={{ marginTop: 20 }}>
            Codes:
          </Typography>
          <List dense>
            {codes.map((code, idx) => (
              <ListItem key={idx}>
                <ListItemText primary={code} />
              </ListItem>
            ))}
          </List>
        </>
      )}

      {urls.length > 0 && (
        <>
          <Typography variant="h6" style={{ marginTop: 20 }}>
            Source URLs:
          </Typography>
          <List dense>
            {urls.map((url, idx) => (
              <ListItem key={idx}>
                <ListItemText
                  primary={
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      {url}
                    </a>
                  }
                />
              </ListItem>
            ))}
          </List>
        </>
      )}

      {/* Loading Overlay */}
      {loading && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            bgcolor: "rgba(255,255,255,0.8)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10,
          }}
        >
          <Box
            component="img"
            src="/brent-2.png" // Replace with your loading image
            alt="Loading"
            sx={{
              width: "auto",
              height: "auto",
              animation: `${rotate} 8s linear infinite, ${pulse} 1.5s ease-in-out infinite, ${scale} 2s ease-in-out infinite`,
            }}
          />
          <Typography variant="h4" sx={{
            marginTop: 2,
            top: 0,
            position: "absolute"
          }}>
            Hold my beer while I run some credit checks....
            <br />
            Shouldn't take me too long.....
          </Typography>
        </Box>
      )}
    </Container>
  );
}

export default App;
